import { Icon } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import LoadingIcon from "../../components/LoadingIcon";
import { ALERT } from "../../services/ResourceRelationsService";
import { ErrorMessagesIconTooltip } from "../Relations/ErrorMessagesIconTooltip";
import { IAccessRelationData } from "./AccessDomainModels";

export function RenderAlert(props: { row: IAccessRelationData }) {
	const row = props.row;
	const { t } = useTranslation();

 	if (row.errorMessages && row.errorMessages.length > 0) {
		return <ErrorMessagesIconTooltip errorMessages={row.errorMessages} />;
	}

	if (!row.employee)
		return null;

	if (row.alert == ALERT.Loading)
		return <LoadingIcon />;
	if (row.alert == ALERT.Error)
		return null;
	if (row.alert == ALERT.Access) {
		if (row.role) {
			let roleName = row.role.name;
			return <Icon title={t("control.relation.accessExist", { label: row.resource.label, roleName })} className="text-warning" >info</Icon>;
		}
		return <Icon title={t("control.relation.accessExistWithoutRole", { label: row.resource.label})} className="text-warning" >info</Icon>;

	} else if (row.alert == ALERT.NoAccess) {
		return <Icon title={t("control.relation.newAccess")} className="text-success" >check_circle</Icon>;
	}

	return null;
}